import {
  AntdLayout,
  Button,
  Card,
  Col,
  Form,
  Input,
  Row,
  Typography,
} from "@pankod/refine-antd";
import { useLogin } from "@pankod/refine-core";
import { LoginPayload } from "apis/auth";
import React from "react";
import styles from "./styles.module.css";

const { Title } = Typography;

export const Login: React.FC = () => {
  const [form] = Form.useForm<LoginPayload>();

  const { mutate: login } = useLogin<LoginPayload>();

  const CardTitle = (
    <Title level={3} className={styles.title}>
      <div className={styles.imageContainer}>
        <img src="./logo.png" alt="Crooklyn Logo" />
      </div>
      Sign in your account
    </Title>
  );

  return (
    <AntdLayout className={styles.layout}>
      <Row
        justify="center"
        align="middle"
        style={{
          height: "100vh",
        }}
      >
        <Col xs={22}>
          <div className={styles.container}>
            <Card title={CardTitle} headStyle={{ borderBottom: 0 }}>
              <Form<LoginPayload>
                layout="vertical"
                form={form}
                onFinish={(values) => {
                  login(values);
                }}
                requiredMark={false}
              >
                <Form.Item
                  name="email"
                  label="Email"
                  rules={[
                    {
                      type: "email",
                      message: "The input is not valid E-mail!",
                    },
                    { required: true },
                  ]}
                >
                  <Input size="large" placeholder="Email" />
                </Form.Item>
                <Form.Item
                  name="password"
                  label="Password"
                  rules={[{ required: true }]}
                  style={{ marginBottom: "30px" }}
                >
                  <Input type="password" placeholder="●●●●●●●●" size="large" />
                </Form.Item>
                <Button type="primary" size="large" htmlType="submit" block>
                  Sign in
                </Button>
              </Form>
            </Card>
          </div>
        </Col>
      </Row>
    </AntdLayout>
  );
};
